import Vue from 'vue'
import VueRouter from 'vue-router'

import Sign from '@/views/Sign.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    alias: ['/home', '/index'],
    name: 'sign',
    component: Sign
  },
  {
    path: '*',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "not-found" */ '@/views/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
